import Vue from 'vue';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import {
  app,
  common,
  glossary,
  validation,
  response,
} from './json';

Vue.use(VueI18Next);

i18next.init({
  ns: ['app', 'common', 'glossary', 'validation', 'response'],
  defaultNS: 'app',
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    format: (value, format) => {
      if (format === 'uppercase') {
        return value.toUpperCase();
      }
      if (format === 'capitalize') {
        return value.toLowerCase().replace(/\b./g, a => a.toUpperCase());
      }
      return value;
    },
  },
  resources: {
    en: {
      app: app.en,
      common: common.en,
      glossary: glossary.en,
      validation: validation.en,
      response: response.en,
    },
    th: {
      app: app.th,
      common: common.th,
      glossary: glossary.th,
      validation: validation.th,
      response: response.th,
    },
  },
});

const i18n = new VueI18Next(i18next);

export default i18n;
